module.exports = "/lucky-balls/img/drum/drum_loop_039.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_039.png
// module id = 1054
// module chunks = 0